import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./Views/App";
import { mainRoutes } from "./Routes/routes";

import store from "./Redux/store";

import * as serviceWorker from "./serviceWorker";
import "./Assets/Styles/bootstrap-grid.min.css";
import "./Assets/Styles/index.css";

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App routes={mainRoutes} />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
